import * as React from 'react'

import {
  IListHeaderDisplayBarProps,
  ListHeader,
} from '~/client/src/shared/components/ListHeader'
import {
  IViewOptionsGroupingProps,
  IViewOptionsSortingProps,
} from '~/client/src/shared/components/ViewOptions/types'
import SortOrder from '~/client/src/shared/enums/SortOrder'

import { useListSelectorContext } from './ListSelectorContext'

type IProps = Pick<IListHeaderDisplayBarProps, 'quickFilters' | 'filter'>

export function ListSelectorToolbar({
  quickFilters,
  filter,
}: IProps): React.ReactElement {
  const ctx = useListSelectorContext()

  // No options means a fixed grouping (ungroupedConfig alone): nothing for Group by to offer.
  const grouping: IViewOptionsGroupingProps | undefined = ctx.groupingOptions
    ?.length
    ? {
        value: ctx.groupingKey,
        defaultValue: ctx.initialGroupingKey,
        options: ctx.groupingOptions,
        onChange: ctx.handleGroupChange,
      }
    : undefined

  // allowNone false: the selector always sorts by something.
  const sorting: IViewOptionsSortingProps | undefined = ctx.sortConfig
    ? {
        value: { key: ctx.sortKey, order: ctx.sortOrder },
        defaultValue: { key: ctx.initialSortKey, order: ctx.initialSortOrder },
        options: ctx.sortConfig.options,
        allowNone: false,
        onChange: value => {
          if (value.key) ctx.handleSortChange(value.key)
          ctx.handleSortOrderChange(value.order ?? SortOrder.ASC)
        },
      }
    : undefined

  return (
    <ListHeader.DisplayBar
      search={{
        value: ctx.searchKey,
        onChange: ctx.setSearchKey,
        placeholder: ctx.searchConfig?.placeholder,
        autoFocus: ctx.searchConfig?.autoFocus,
        testId: ctx.searchConfig?.inputTestId,
      }}
      quickFilters={quickFilters}
      filter={filter}
      grouping={grouping}
      sorting={sorting}
    />
  )
}
